import React, { useEffect } from 'react'
import { useLocation } from '@reach/router'
import { useFormContext } from '../context/form.context'
import { useLangContext } from '../context/lang.context'
import { alpha, colors, s } from '../style'
import FormDynamic from './FormDynamic'
import CloseIcon from '../assets/CloseIcon'
import queryString from 'query-string'

const formName = {
  MESSAGE: {
    pl: 'Wycena kontenerów',
    en: 'Container Quote',
    zh: '集装箱报价',
  },
  QUOTE: {
    pl: 'Wycena transportu',
    en: 'Transport Quote',
  },
  COLLAB: {
    pl: 'Formularz współpracy',
    en: 'Collaboration Form',
  },
  CARRIER: {
    pl: 'Fomularz przewoźnika',
    en: 'Carrier Form',
  },
}

const FormPopup = () => {
  const { lang } = useLangContext()
  const { formOpen, formType, setFormOpen, setFormType } = useFormContext()
  const location = useLocation()
  const path = location.pathname
  const params = queryString.parse(location.search)

  /* eslint-disable */
  useEffect(() => {
    if (params?.form?.includes('open')) setFormOpen(true)

    if (path.includes('transport') || path.includes('spedycja'))
      setFormType('QUOTE')

    if (
      path.includes('kariera') ||
      path.includes('kontakt') ||
      path.includes('blog') ||
      path.includes('csr')
    )
      setFormType('MESSAGE')

    if (
      path.includes('wspolpraca') ||
      path.includes('logisty') ||
      path.includes('magazyn')
    )
      setFormType('COLLAB')

    if (path.includes('przewoznik')) setFormType('CARRIER')
  }, [path])
  /* eslint-enable */

  return (
    <>
      <div
        aria-label='open'
        css={[sDimmer, !formOpen && { opacity: 0, pointerEvents: 'none' }]}
        onClick={() => setFormOpen(false)}
        onKeyPress={() => setFormOpen(false)}
        tabIndex={0}
        role='button'
      />
      <div
        css={[sOuter, !formOpen && { transform: 'translateX(100%)' }]}
        id={formOpen ? 'popup_open' : 'popup_close'}>
        <div css={{ position: 'relative', top: 0, left: 0 }}>
          <div
            css={[
              sOpenButton,
              !formOpen && {
                animation:
                  'popup-widget-button 2s ease-out infinite both alternate',
                  backgroundColor: '#ffde59',
                  color: '#2a2c69',
              },
            ]}
            onClick={() => setFormOpen(!formOpen)}
            onKeyPress={() => setFormOpen(!formOpen)}
            tabIndex={0}
            role='button'>
            {formName[formType][lang]}
          </div>
          <div css={[sInner]}>{formOpen && <FormDynamic popup />}</div>
          <div
            css={sCloseIcon}
            onClick={() => setFormOpen(false)}
            onKeyPress={() => setFormOpen(false)}
            tabIndex={0}
            role='button'>
            <CloseIcon />
          </div>
        </div>
      </div>
    </>
  )
}

const sCloseIcon = {
  position: 'absolute',
  right: '1.5rem',
  top: '1.5rem',
  cursor: 'pointer',
  zIndex: 2000,
  opacity: 0.3,
  svg: {
    width: '1.5rem',
    height: '1.5rem',
  },
  [s.xs]: {
    right: '1rem',
    top: '1rem',
    svg: {
      width: '1rem',
      height: '1rem',
    },
  },
}

const sOuter = {
  position: 'fixed',
  top: 0,
  right: 0,
  height: '100vh',
  maxHeight: '100vh',
  width: 'max-content',
  zIndex: 2000,
  display: 'flex',
  alignItems: 'center',
  transition: 'transform 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
  willChange: 'transform',
}

const sOpenButton = {
  transition:
    'all 0.5s cubic-bezier(0.25, 1, 0.5, 1), background-color 0.4s linear',
  willChange: 'opacity, letter-spacing, padding, box-shadow',
  position: 'absolute',
  top: '80%',
  left: '0',
  cursor: 'pointer',
  fontSize: '0.75rem',
  letterSpacing: '0.05em',
  fontWeight: 700,
  backgroundColor: 'white',
  padding: '0 2rem',
  borderRadius: '2rem 2rem 0 0',
  height: 48,
  width: 'max-content',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textTransform: 'uppercase',
  transformOrigin: 'center center',
  transform: 'translate(calc(-50% - 1.5rem), -50%) rotate(-90deg)',
  whiteSpace: 'nowrap',
  wordSpacing: '0.5rem',
  boxShadow: `0 0 32px ${colors.text.concat(alpha[30])}`,
  [s.xs]: {
    fontSize: '0.75rem',
    height: 32,
    transform: 'translate(calc(-50% - 1rem), 0%) rotate(-90deg)',
    top: 'auto',
    bottom: '9rem',
  },

  '&:hover': {
    boxShadow: `0 0 64px ${colors.white.concat(alpha[100])}`,
  },

  // '&::before': {
  //   content: `""`,
  //   position: 'absolute',
  //   backgroundColor: '#0074D9',
  //   bottom: -50,
  //   height: 50,
  //   width: 25,
  //   borderTopLeftRadius: 25,
  //   boxShadow: `0 -25px 0 0 #001f3f`,
  // },
}

const sInner = {
  position: 'relative',
  top: 0,
  left: 0,
  boxSizing: 'border-box',
  height: '100vh',
  maxHeight: '100vh',
  backgroundColor: 'white',
  borderRadius: '2rem 0 0 2rem',
  overflowY: 'scroll', // here?
  overflowx: 'visible',
  [s.xs]: {
    width: 'calc(100vw - 2rem)',
    padding: '2rem',
  },
  [s.sm]: {
    width: '75vw',
    padding: '2rem',
  },
  [s.md]: {
    padding: '4rem',
  },
  [s.lg]: {
    width: '50vw',
  },

  '::-webkit-scrollbar': {
    width: 6,
    height: 0,
    backgroundColor: 'white',
  },

  '::-webkit-scrollbar-track': {
    backgroundColor: 'white',
  },

  '::-webkit-scrollbar-track:hover': {
    backgroundColor: '#2B2A294D',
  },

  '::-webkit-scrollbar-thumb': {
    borderRadius: 12,
    backgroundColor: '#26275E',
  },

  '::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#2b2c69',
  },
}

const sDimmer = {
  transition: 'opacity 0.5s cubic-bezier(0.25, 1, 0.5, 1)',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backgroundColor: colors.greyDarker.concat(alpha[90]),
  zIndex: 1100,
  cursor: 'pointer',
}

export default FormPopup
